import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDatepickerMaskDirective } from '@anihis/shared/src/shared/directive/mat-datepicker-mask.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { TranslocoModule } from '@jsverse/transloco';
import {
  getMaxBirthDate,
  getMinAnimalBirthDate,
} from '@anihis/shared/src/validators/birth-date.validators';

@Component({
  selector: 'anihis-chemotherapy-protocol',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDatepickerMaskDirective,
    MatNativeDateModule,
    MatButtonModule,
    TranslocoModule,
  ],
  templateUrl: './chemotherapy-protocol.component.html',
  styleUrls: ['./chemotherapy-protocol.component.scss'],
})
export class ChemotherapyProtocolComponent implements OnInit {
  minDate = getMinAnimalBirthDate();
  today = getMaxBirthDate();

  @Output() formChange = new EventEmitter<any>();

  form!: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      chemotherapyGeneral: this.fb.group({
        diagnosis: [''],
        date: [''],
        veterinarian: [''],
        bodyWeightKg: [''],
        bodySurfaceM2: [''],
      }),
      chemotherapyMedication: this.fb.group({
        premedication: [''],
        medicament: [''],
        dose: [''],
        administrationMode: [''],
        volumeMgH: [''],
        ivCatheter: [''],
        adverseEvents: [''],
        sedationYesNo: [''],
        sedativeDetails: [''],
        postTreatment: [''],
      }),
      chemotherapyBloodCount: this.fb.group({
        wbc: [''],
        ne: [''],
        rbc: [''],
        plt: [''],
      }),
      chemotherapyBiochemistry: this.fb.group({
        alt: [''],
        alp: [''],
        ure: [''],
        cre: [''],
        glu: [''],
        tp: [''],
      }),
      chemotherapyVeterinarian: this.fb.group({
        veterinarianName: [''],
      }),
    });
  }

  ngOnInit(): void {
    // Emit initial value so parent can patch or show current state
    this.emitAll();
    this.form.valueChanges.subscribe(() => this.emitAll());
  }

  private emitAll() {
    this.formChange.emit(this.form.value);
  }
}
